import { render, staticRenderFns } from "./delete-subpackage.vue?vue&type=template&id=120fb00c&"
import script from "./delete-subpackage.vue?vue&type=script&lang=js&"
export * from "./delete-subpackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports